import { render, staticRenderFns } from "./ProgramDashboard.vue?vue&type=template&id=86ae6be8&scoped=true&"
import script from "./ProgramDashboard.vue?vue&type=script&lang=js&"
export * from "./ProgramDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae6be8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86ae6be8')) {
      api.createRecord('86ae6be8', component.options)
    } else {
      api.reload('86ae6be8', component.options)
    }
    module.hot.accept("./ProgramDashboard.vue?vue&type=template&id=86ae6be8&scoped=true&", function () {
      api.rerender('86ae6be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/program/views/ProgramDashboard.vue"
export default component.exports